"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Collection } from "Collection";
import { Model } from "Model";
import { FormsModel } from "Models/FormsModel";
import { Fields } from "Constants/objects";
import { FormFieldsCollection } from "Collections/FormFieldsCollection";
import { FormGroupsCollection } from "Collections/FormGroupsCollection";
import { FormDetailsCollection } from "Collections/FormDetailsCollection";
import { FormFieldEventsCollection } from "Collections/FormFieldEventsCollection";
import { FormFilterFieldsCollection } from "Collections/FormFilterFieldsCollection";
import { SubsystemsCollection } from "Collections/SubsystemsCollection";
import { FormButtonsCollection } from "Collections/FormButtonsCollection";
import { FormButtonEventsCollection } from "Collections/FormButtonEventsCollection";
import { FormFilterFieldEvents } from "Collections/FormFilterFieldEventsCollection";
import { AppObjectsCollection } from "Collections/AppObjectsCollection";
import { FormDecorationElementsCollection } from "Collections/FormDecorationElementsCollection";
export var loadObjectData = function loadObjectData() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? {} : _ref$filter,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? -1 : _ref$page,
      _ref$objectName = _ref.objectName,
      objectName = _ref$objectName === void 0 ? '' : _ref$objectName;

  if (!objectName) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve) {
    var ObjectModel = Model.extend({
      object: objectName
    });
    var objectColl = new (Collection.extend({
      model: ObjectModel,
      object: objectName
    }))();
    objectColl.fetch({
      data: {
        Page: page || -1,
        Columns: columns,
        Filters: filter
      },
      success: function success(collection) {
        resolve(collection.toJSON());
      }
    });
  });
};
/**
 * @param id
 * @return {*}
 */

export var loadFormMetadata = function loadFormMetadata(id) {
  if (id == null) return Promise.resolve({});
  return new Promise(function (resolve) {
    new FormsModel().fetch({
      data: {
        Filters: {
          ID: id
        },
        Columns: [Fields.ID, Fields.FormID, Fields.Type, Fields.ViewMode, Fields.Title, Fields.Name, Fields.ObjectID, Fields.ObjectID_Name, Fields.MainGroupID, Fields.EditMode, Fields.ObjectID_KeyObjectFieldID_Name, Fields.ObjectID_KeyObjectFieldID_FieldType, Fields.ParentFieldID, Fields.ParentFieldID_Name, Fields.ParentFieldID_LinkedObjectID, Fields.IsShowRoot, Fields.RootName, Fields.IsShowTotals, Fields.ParentFieldID_Type]
      },
      success: function success(form) {
        resolve(form.toJSON());
      }
    });
  });
};
/**
 * @param {number|array} formID
 * @return {Promise<array>}
 */

export var loadFormFields = function loadFormFields(formID) {
  if (formID == null) return Promise.resolve([]);
  return new Promise(function (resolve) {
    new FormFieldsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.FormID, Fields.FormID_Name, Fields.ObjectFieldID, Fields.GroupID, Fields.GroupID_ParentGroupID, Fields.GroupID_Title, Fields.Title, Fields.DisplayField, Fields.TitlePosition, Fields.IsShowTitle, Fields.IsReadOnly, Fields.IsVisible, Fields.Order, Fields.SortByDefault, Fields.ObjectFieldID_Name, Fields.ObjectFieldID_FieldType, Fields.ObjectFieldID_LinkedObjectID, Fields.ObjectFieldID_Name, Fields.ObjectFieldID_LinkedObjectID_Name, Fields.DisplayType, Fields.Name, Fields.ObjectFieldID_DisplayObjectFieldID, Fields.ObjectFieldID_DisplayObjectFieldID_Name, Fields.ObjectFieldID_DisplayObjectFieldID_FieldType, Fields.ObjectFieldID_KeyObjectFieldID, Fields.ObjectFieldID_KeyObjectFieldID_Name, Fields.ObjectFieldID_KeyObjectFieldID_FieldType, Fields.ObjectFieldID_NumberScale, Fields.ObjectFieldID_NumberPrecision, Fields.ObjectFieldID_IsKey, Fields.ObjectFieldID_IsRequired, Fields.LineCount, Fields.ObjectFieldID_IsTimeAllowed, Fields.DisplayCustomParam, Fields.TotalFunction, Fields.Width],
        Filters: {
          FormID: formID
        },
        Page: -1
      },
      success: function success(formFields) {
        resolve(formFields.toJSON());
      }
    });
  });
};
/**
 * @param groupType
 * @param {number} formID
 * @return {Promise<array>}
 */

export var loadFormGroups = function loadFormGroups() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      groupType = _ref2.groupType,
      formID = _ref2.formID;

  if (formID == null) return Promise.resolve([]);
  var filter = {
    FormID: formID
  };

  if (groupType) {
    filter.GroupType = {
      '=': groupType
    };
  }

  return new Promise(function (resolve) {
    new FormGroupsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.FormID, Fields.ParentGroupID, Fields.Title, Fields.Orientation, Fields.IsShowTitle, Fields.GroupType, Fields.IsCollapsed, Fields.IsVisible, Fields.Order, Fields.Icon, Fields.TitleType, Fields.Width],
        Filters: filter,
        Page: -1,
        Sorts: [Fields.Order]
      },
      success: function success(formGroups) {
        resolve(formGroups.toJSON());
      }
    });
  });
};
/**
 * @param {number} formID
 * @return {Promise<array>}
 */

export var loadSubForms = function loadSubForms(formID) {
  if (formID == null) return Promise.resolve([]);
  return new Promise(function (resolve) {
    new FormDetailsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.FormID, Fields.FormID_Name, Fields.FormID_ObjectID, Fields.FormID_ObjectID_Name, Fields.FormID_ObjectID_KeyObjectFieldID_Name, Fields.DetailObjectFieldID_Name, Fields.DetailFormID, Fields.MasterObjectFieldID_Name, Fields.ID, Fields.Name, Fields.GroupID, Fields.Order, Fields.DetailFormID_Type, Fields.NestedFieldID, Fields.NestedFieldID_Name, Fields.RelationType, Fields.DetailFormID_Name, Fields.Width],
        Filters: {
          FormID: formID
        }
      },
      success: function success(details) {
        resolve(details.toJSON());
      }
    });
  });
};
export var loadUserFunctions = function loadUserFunctions(ids) {
  if (Array.isArray(ids) && !ids.length) return Promise.resolve([]);
  return new Promise(function (resolve) {
    new FormFieldEventsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.EventTypeID, Fields.FormFieldID, Fields.FunctionName],
        Filters: {
          FormFieldID: ids
        },
        Page: -1
      },
      success: function success(events) {
        resolve(events.toJSON());
      }
    });
  });
};
export var loadFilterFields = function loadFilterFields() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      filter = _ref3.filter,
      id = _ref3.id;

  var lFilter = filter;
  if (id == null) return Promise.resolve([]);

  if (!lFilter) {
    lFilter = _defineProperty({}, Fields.FormID, id);
  }

  return new Promise(function (resolve) {
    new FormFilterFieldsCollection().fetch({
      data: {
        Columns: [Fields.FormID_ObjectID, Fields.FormID_ObjectID_Name, Fields.DisplayField, Fields.DisplayType, Fields.FormID, Fields.FieldType, Fields.GroupID, Fields.GroupID_ParentGroupID, Fields.GroupID_Title, Fields.ID, Fields.IsShowTitle, Fields.IsReadOnly, Fields.IsRequired, Fields.IsVisible, Fields.LinkedObjectID_DisplayObjectFieldID, Fields.LinkedObjectID_DisplayObjectFieldID_Name, Fields.LinkedObjectID_DisplayObjectFieldID_FieldType, Fields.LinkedObjectID_KeyObjectFieldID, Fields.LinkedObjectID_KeyObjectFieldID_Name, Fields.LinkedObjectID_KeyObjectFieldID_FieldType, Fields.LinkedObjectID, Fields.LinkedObjectID_Name, Fields.Name, Fields.ObjectFieldID, Fields.ObjectFieldID_Name, Fields.ObjectFieldID_NumberScale, Fields.ObjectFieldID_NumberPrecision, Fields.ObjectFieldID_IsKey, Fields.ObjectFieldID_IsRequired, Fields.ObjectFieldID_IsTimeAllowed, Fields.ObjectFieldID_FieldType, Fields.ObjectFieldID_LinkedObjectID, Fields.ObjectFieldID_LinkedObjectID_Name, Fields.ObjectFieldID_DisplayObjectFieldID, Fields.ObjectFieldID_DisplayObjectFieldID_Name, Fields.ObjectFieldID_DisplayObjectFieldID_FieldType, Fields.ObjectFieldID_KeyObjectFieldID, Fields.ObjectFieldID_KeyObjectFieldID_Name, Fields.ObjectFieldID_KeyObjectFieldID_FieldType, Fields.Order, Fields.SortByDefault, Fields.Title, Fields.TitlePosition, Fields.IsShowInMainForm, Fields.IsMultiselect, Fields.Width],
        Filters: lFilter,
        Page: -1
      },
      success: function success(filterFields) {
        resolve(filterFields.toJSON());
      }
    });
  });
};
export var loadSubSystem = function loadSubSystem(formID) {
  return new Promise(function (resolve) {
    new SubsystemsCollection().fetch({
      data: {
        Columns: [Fields.FormID, Fields.FormID_Type, Fields.FormID_ViewMode, Fields.FormID_Title],
        Page: -1,
        Filters: _defineProperty({}, Fields.FormID, formID)
      },
      success: function success(collection) {
        resolve(collection.toJSON());
      }
    });
  });
};
export var loadButtons = function loadButtons(_ref4) {
  var formID = _ref4.formID,
      position = _ref4.position,
      _ref4$sorts = _ref4.sorts,
      sorts = _ref4$sorts === void 0 ? [] : _ref4$sorts;
  if (!formID) return;
  var filter = {
    FormID: formID
  };
  if (position != null) filter[Fields.Position] = position;
  return new Promise(function (resolve) {
    new FormButtonsCollection().fetch({
      data: {
        Columns: [Fields.ActionFormID, Fields.ButtonType, Fields.CustomOperation, Fields.CustomParameters, Fields.FormID, Fields.FormID_Type, Fields.GroupID, Fields.ID, Fields.Icon, Fields.Name, Fields.Order, Fields.Position, Fields.Title, Fields.ActionFormID_Type, Fields.TitleType, Fields.Width],
        Filters: filter,
        Sorts: sorts,
        Page: -1
      },
      success: function success(formButtonsData) {
        resolve(formButtonsData.toJSON());
      }
    });
  });
};
export var loadFormButtonEvents = function loadFormButtonEvents() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (Array.isArray(ids) && !ids.length) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve) {
    new FormButtonEventsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.EventTypeID, Fields.FormButtonID, Fields.FunctionName],
        Filters: {
          FormButtonID: ids
        },
        Page: -1
      },
      success: function success(events) {
        resolve(events.toJSON());
      }
    });
  });
};
export var loadFormFilterFieldEvents = function loadFormFilterFieldEvents() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (Array.isArray(ids) && !ids.length) {
    return Promise.resolve([]);
  }

  return new Promise(function (resolve) {
    new FormFilterFieldEvents().fetch({
      data: {
        Columns: [Fields.ID, Fields.EventTypeID, Fields.FormFilterFieldID, Fields.FunctionName],
        Filters: {
          FormFilterFieldID: ids
        },
        Page: -1
      },
      success: function success(events) {
        resolve(events.toJSON());
      }
    });
  });
};
export var loadAppObjectsCollection = function loadAppObjectsCollection(filter) {
  return new Promise(function (resolve) {
    new AppObjectsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.Name, Fields.GroupID, Fields.KeyObjectFieldID, Fields.KeyObjectFieldID_Name, Fields.DisplayObjectFieldID, Fields.DisplayObjectFieldID_Name],
        Filters: filter,
        Page: -1
      },
      success: function success(events) {
        resolve(events.toJSON());
      }
    });
  });
};
export var loadFormDecorationElements = function loadFormDecorationElements(formID) {
  if (formID == null) return Promise.resolve([]);
  return new Promise(function (resolve) {
    new FormDecorationElementsCollection().fetch({
      data: {
        Columns: [Fields.ID, Fields.FormID, Fields.Name, Fields.GroupID, Fields.Title, Fields.IsVisible, Fields.Order, Fields.DisplayType, Fields.Width, Fields.LineCount],
        Filters: {
          FormID: formID
        },
        Page: -1
      },
      success: function success(events) {
        resolve(events.toJSON());
      }
    });
  });
};